const isRegion = (content, country, city, segment) => {
  const {
    region_conference: conference,
    region_geographic: geography,
    region_segment: regionSegment,
  } = content
  if (
    conference ||
    (geography?._type === "country" && geography.abbreviation !== country) ||
    (geography?._type === "city" && city !== geography.abbreviation) ||
    (regionSegment && segment !== regionSegment)
  )
    return false
  return true
}

export default isRegion
